import React from "react";
import {
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FieldInput from "../utils/FieldInput";

export default function MeasurementsSection({
  measurementFields,
  roleForm,
  handleChange,
  errors = {}
}) {
  const sections = [
    { key: "mens", title: "Men's Sizes" },
    { key: "womens", title: "Women's Sizes" },
    { key: "kids", title: "Child / Young Adult Sizes" },
  ];

  return (
    <>
      {sections.map(({ key, title }) => (
        <Box mt={2} key={key}>
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6">{title}</Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ px: 2, py: 1 }}>
              <Grid container spacing={2}>
                {measurementFields[key].map((field) => (
                  <Grid item xs={12} sm={6} md={4} key={field.name}>
                    <FieldInput
                      field={field}
                      roleForm={roleForm}
                      onChange={handleChange}
                      errors={errors}  // ADD THIS LINE
                    />
                  </Grid>
                ))}
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Box>
      ))}
    </>
  );
}
